<template>
    <div class="rider-icon" :style="{ height: calHeight + 'px', width: calWidth + 'px' }">
        <v-icon :size="calIconSize" :color="color">
            <slot />
        </v-icon>

        <div v-if="showText" class="rider-icon__text" :class="iconClass">
            {{ text }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue';
import { computed } from 'vue';

const slots = useSlots();

const props = withDefaults(
    defineProps<{
        size?: number;
        sizeWidth?: number;
        sizeHeight?: number;
        iconSize?: number;
        color?: string;
        text?: string;
    }>(),
    {
        color: 'rgba(0, 0, 0, 0.87)',
        text: ''
    }
);

const calIconSize = computed(() => {
    return props.iconSize ? props.iconSize : props.size;
});

const calWidth = computed(() => {
    return props.sizeWidth ? props.sizeWidth : props.size;
});

const calHeight = computed(() => {
    return props.sizeHeight ? props.sizeHeight : props.size;
});

const showText = computed(() => {
    return !!props.text;
});

const iconClass = computed(() => {
    return slots.default && slots.default[0]?.text ? 'rider-icon__text--' + slots.default[0]?.text : null;
});
</script>

<style lang="scss">
.rider-icon {
    display: inline-block;
    text-indent: 5px;

    &__text {
        display: inline-block;
        font-size: 14px;
        text-align: center;
        height: 18px;
        line-height: 18px;
    }
}
</style>
